<template>
  <div class="ChangePassword">
    <!-- 顶部提示 -->
    <div class="topTip">
      <label class="msg">{{ tipMsg }}</label>
    </div>
    <div class="list">
      <!-- 基础信息 -->
      <div class="module">
        <div class="item-tile">
          <label class="item-tile-name">基础信息</label>
        </div>
        <!-- 姓名输入 -->
        <div class="item">
          <label class="item-name">姓名</label>
          <input type="text" placeholder="请输入姓名" v-model="name" :disabled="notEditable" class="placeholder" />
        </div>
        <!-- 身份证号输入 -->
        <div class="item">
          <label class="item-name">身份证号</label>
          <input type="text" placeholder="请输入身份证号" v-model="idNo" :disabled="notEditable" class="placeholder" />
        </div>
        <!-- 地区选择器 -->
        <div class="item">
          <label class="item-name">所在地区</label>
          <input type="text" :disabled="notEditable" readonly @click.stop="citySelectVisible = true"
            :value="citySelectResult" placeholder="请选择省市区" class="placeholder" />
          <CitySelect ref="cityselect" v-model="citySelectVisible" :callback="citySelectCallback" :items="districtData"
            :ready="cityDataReady"></CitySelect>
        </div>
        <!-- 详细地址 -->
        <div class="item">
          <div class="item-name">详细地址</div>
          <input type="text" placeholder="请填写具体地址" v-model="addressDetail" :disabled="notEditable"
            class="placeholder" />
        </div>
      </div>
      <!-- 紧急联系人一 -->
      <div class="module">
        <div class="item-tile">
          <label class="item-tile-name">紧急联系人一</label>
        </div>
        <div class='item'>
          <div class='item-name' @click="showPicker1 = true">关系：</div>
          <input type="text" :disabled="notEditable" readonly @click.stop="showPicker1 = true" :value="relation1"
            placeholder="请选择与紧急联系人的关系" class="placeholder" />
          <!-- 单选弹窗 -->
          <van-popup v-model="showPicker1" position="bottom" round>
            <van-picker :columns="relationArray" show-toolbar :title="请选择" value-key="label"
              @confirm="onSelectRelationConfirm" @cancel="showPicker1 = false" />
          </van-popup>
        </div>
        <div class="item">
          <label class="item-name">姓名：</label>
          <input type='text' placeholder='请输入紧急联系人姓名' v-model='emergency_name1' class='placeholder'
            :disabled="notEditable"></input>
        </div>
        <div class="item">
          <label class="item-name">手机号码：</label>
          <input type='number' placeholder='请输入紧急联系人手机号码' v-model='emergency_phone1' class='placeholder'
            :disabled="notEditable"></input>
        </div>
      </div>
      <!-- 紧急联系人二 -->
      <div class="module">
        <div class="item-tile">
          <label class="item-tile-name">紧急联系人二</label>
        </div>
        <div class='item'>
          <div class='item-name' @click="showPicker2 = true">关系：</div>
          <input type="text" :disabled="notEditable" readonly @click.stop="showPicker2 = true" :value="relation2"
            placeholder="请选择与紧急联系人的关系" class="placeholder" />
          <!-- 单选弹窗 -->
          <van-popup v-model="showPicker2" position="bottom" round>
            <van-picker :columns="relationArray" show-toolbar :title="请选择" value-key="label"
              @confirm="onSelectRelationConfirm2" @cancel="showPicker2 = false" />
          </van-popup>
        </div>
        <div class="item">
          <label class="item-name">姓名：</label>
          <input type='text' placeholder='请输入紧急联系人姓名' v-model='emergency_name2' class='placeholder'
            :disabled="notEditable"></input>
        </div>
        <div class="item">
          <label class="item-name">手机号码：</label>
          <input type='number' placeholder='请输入紧急联系人手机号码' v-model='emergency_phone2' class='placeholder'
            :disabled="notEditable"></input>
        </div>
      </div>
      <!-- 其他信息一 -->
      <div class="module">
        <div class="item-tile">
          <label class="item-tile-name">其他信息</label>
        </div>
        <!-- 手机号码 -->
        <div class="item">
          <div class="item-name">手机号码</div>
          <input type="number" placeholder="请填写你本人手机号码" v-model="phone" :disabled="notEditableForPhone"
            class="placeholder" />
        </div>
        <!-- 短信验证码 -->
        <div class="item" v-if="!notEditable">
          <div class="item-name">验证码</div>
          <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
          <button class="code font-color-red" :disabled="disabled" :class="disabled === true ? 'on' : ''"
            @click="sendSMSCode">
            {{ text }}</button>
        </div>
        <!-- 图像验证 -->
        <div class="item" v-if="isShowCode">
          <div class="item-name">图形验证</div>
          <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
          <div class="codeVal" @click="imagesCodeTap"><img :src="codeUrl" /></div>
        </div>

        <!-- 身份证照片上传 -->
        <div class="containerColumnOnly">
          <!-- 正面照片 -->
          <div class="picList acea-row row-middle">
            <div class="pictrue" v-for="(item, index) in frontPics" :key="index">
              <img :src="item" />
              <span class="iconfont icon-guanbi1 font-color-red" @click="delPic('front')"></span>
            </div>
            <VueCoreImageUpload v-if="frontPics.length < 1" class="pictrue acea-row row-center-wrapper row-column"
              @imageuploaded="uploadFrontPic" :crop="false" compress="80" :headers="headers" :max-file-size="5242880"
              :credentials="false" inputAccept="image/*" inputOfFile="file" :url="uploadImgUrl">
              <span class="iconfont icon-icon25201"></span>
              <div>上传身份证正面</div>
            </VueCoreImageUpload>
          </div>
          <!-- 反面照片 -->
          <div class="picList acea-row row-middle">
            <div class="pictrue" v-for="(item, index) in backPics" :key="index">
              <img :src="item" />
              <span class="iconfont icon-guanbi1 font-color-red" @click="delPic('back')"></span>
            </div>
            <VueCoreImageUpload v-if="backPics.length < 1" class="pictrue acea-row row-center-wrapper row-column"
              @imageuploaded="uploadBackPic" :crop="false" compress="80" :headers="headers" :max-file-size="5242880"
              :credentials="false" inputAccept="image/*" inputOfFile="file" :url="uploadImgUrl">
              <span class="iconfont icon-icon25201"></span>
              <div>上传身份证反面</div>
            </VueCoreImageUpload>
          </div>
        </div>
        <!-- 自拍照上传 -->
        <div class="containerColumnOnly2">
          <div class="picList acea-row row-middle">
            <div class="pictrue" v-for="(item, index) in selfPics" :key="index">
              <img :src="item" />
              <span class="iconfont icon-guanbi1 font-color-red" @click="delPic('self')"></span>
            </div>
            <VueCoreImageUpload v-if="selfPics.length < 1" class="pictrue acea-row row-center-wrapper row-column"
              @imageuploaded="uploadSelfPic" :crop="false" compress="80" :headers="headers" :max-file-size="5242880"
              :credentials="false" inputAccept="image/*" inputOfFile="file" :url="uploadImgUrl">
              <span class="iconfont icon-icon25201"></span>
              <div>上传清晰自拍照</div>
            </VueCoreImageUpload>
          </div>
        </div>
      </div>
    </div>
    <div class="confirmBnt bg-color-red" @click="submitRealName">{{btnText}}</div>
    <div class="addConstomerBtn" @click="$router.push({ path: '/news_detail/1'})">{{addConstomerBtnText}}</div>
    <div style="height: 1rem;"></div>
    <div id="mapContainer" hidden="true"></div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { isWeixin } from "@utils/index";
import cookie from "@utils/store/cookie";
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import attrs, { required, alpha_num, chs_phone, chs, idNoValid } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone, getCodeApi, realNameAuth } from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getCity } from "@api/public";
import VueCoreImageUpload from "vue-core-image-upload";
import { Field, Picker, Popup } from "vant";
import { wxShowLocation } from "@libs/wechat";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";

export default {
  name: "BindingPhone",
  components: {
    CitySelect,
    VueCoreImageUpload,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker
  },
  props: {},
  data: function () {
    return {
      uploadImgUrl: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      tipMsg: '',
      name: "",
      idNo: "",
      addressDetail: "",
      phone: "", //手机号
      captcha: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      
      notEditable: false,
      districtData: [],
      citySelectVisible: false,
      citySelectModel: {},
      citySelectResult: "",
      cityDataReady: false,

      relationArray: ['配偶', '父母', '亲戚', '朋友'],
      relation1: '',
      emergency_name1: '',
      emergency_phone1: '',
      relation2: '',
      emergency_name2: '',
      emergency_phone2: '',

      frontPics: [],
      backPics: [],
      selfPics: [],
      authUrl: '',
      btnText: '下一步',
      addConstomerBtnText: '',

      //关系弹窗控制字段
      showPicker1: false,
      showPicker2: false,

      //地图定位
      map: null,
      AMap: null,
      location: ''

    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function () {
    //定位
    if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) {
     this.getWXLocation();
    }
    this.getKeyCode();
    this.initData();
    //this.getCityList();
  },
  methods: {
    initData() {
      let userInfo = this.userInfo;
      this.notEditable = (userInfo.auth_status == 1 || userInfo.auth_status == 2); //待审核和已认证，不可以编辑
      this.notEditableForPhone = this.notEditable;
      this.btnText = this.notEditable ? '查看个人信息授权书' : '下一步';
      var tipMsg = '';
      var addConstomerBtnText = '';
      if (userInfo.auth_status == 0) {
        tipMsg = '请正确填写信息，您的隐私数据会得到有效保护。';
        addConstomerBtnText = '添加客服企业微信，加速审核';
        this.getCityList();
      } else if (userInfo.auth_status == 1) {
        tipMsg = '您的认证信息已提交，请耐心等待审核结果。';
        addConstomerBtnText = '添加客服企业微信，加速审核';
      } else if (userInfo.auth_status == 2) {
        tipMsg = '恭喜，您的认证信息已通过审核。';
        addConstomerBtnText = '添加客服企业微信';
      } else if (userInfo.auth_status == 3) {
        tipMsg = '您的认证信息未通过审核，请重新填写并提交。';
        addConstomerBtnText = '添加客服企业微信，了解更多';
        this.getCityList();
      }
      this.tipMsg = tipMsg;
      this.addConstomerBtnText = addConstomerBtnText;

      if (userInfo.auth_status > 0) {
        let addressInfoArr = userInfo.addres.split('[#]');
        if (addressInfoArr.length == 4) {
          this.citySelectResult = addressInfoArr[0] + " " + addressInfoArr[1] + " " + addressInfoArr[2];
          this.addressDetail = addressInfoArr[3];
          this.citySelectModel = {
              itemName1: addressInfoArr[0],
              itemName2: addressInfoArr[1],
              itemName3: addressInfoArr[2]
          };
        }

        var emergencyContactArr = userInfo.emergency_contact.split('[##]');
        if(emergencyContactArr.length == 2) {
          var emergencyContact1 = emergencyContactArr[0].split('[#]');
          this.relation1 = emergencyContact1[0];
          this.emergency_name1 = emergencyContact1[1];
          this.emergency_phone1 = emergencyContact1[2];
          let emergencyContact2 = emergencyContactArr[1].split('[#]');
          this.relation2 = emergencyContact2[0];
          this.emergency_name2 = emergencyContact2[1];
          this.emergency_phone2 = emergencyContact2[2];
        } 
        else if(userInfo.auth_status != 3) { //待审核或已认证
          this.relation1 = '--';
          this.emergency_name1 = '--';
          this.emergency_phone1 = '00';
          this.relation2 = '--';
          this.emergency_name2 = '--';
          this.emergency_phone2 = '00';
        }

        this.name = userInfo.real_name;
        this.phone = userInfo.phone;
        this.idNo = userInfo.card_id;
        this.frontPics = [userInfo.card_img_front];
        this.backPics = [userInfo.card_img_back];
        this.selfPics = [userInfo.self_img];
      }
      else {
        setTimeout(() => {
          this.$dialog.alert({
            mes: '为了快速获得购买资格，请确保本人认证评估！'
          }, () => { });
        }, 500);
        if(userInfo.phone) {
          this.phone = userInfo.phone;
          this.notEditableForPhone = true;
        }
      }

      if (cookie.get(LATITUDE) && cookie.get(LONGITUDE)) {
        this.location = cookie.get(LONGITUDE) + ',' + cookie.get(LATITUDE);
      }
    },
    uploadFrontPic(res){
      if (!res || res.status !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
    
      this.frontPics.push(res.data.url);
    },
    uploadBackPic(res){
      if (!res || res.status !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
    
      this.backPics.push(res.data.url);
    },
    uploadSelfPic(res){
      if (!res || res.status !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
    
      this.selfPics.push(res.data.url);
    },
    delPic(type) {
      if(this.notEditable) {
        return this.$dialog.toast({ mes: "当前状态不支持编辑" });
      }
      if(type === 'front') {
        this.frontPics = [];
      } else if(type === 'back') {
        this.backPics = [];
      } else {
        this.selfPics = [];
      }
    },
    imagesCodeTap() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
    },
    getKeyCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    getCityList: function() {
      let that = this;
      getCity()
        .then(res => {
          that.districtData = res.data;
          that.cityDataReady = true;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    citySelectCallback(ret) {
      this.citySelectModel = ret;
      this.citySelectResult = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
    },
    onSelectRelationConfirm(value) {
      this.relation1 = value;
      this.showPicker1 = false;
    },
    onSelectRelationConfirm2(value) {
      this.relation2 = value;
      this.showPicker2 = false;
    },
    
    async submitRealName() {
      if (this.notEditable) {
        this.$router.push({
          path: "/user/auth_statement",
        });
        return;
      }

      let that = this;
      const { name, idNo, citySelectResult, addressDetail, 
        relation1, emergency_name1, emergency_phone1, relation2, emergency_name2, emergency_phone2,
         phone, captcha, frontPics, backPics, selfPics } = that;
      try {
        await that
          .$validator({
            name: [
              required(required.message("姓名")),
              chs(chs.message('姓名'))
            ],
            idNo: [
              required(required.message("身份证号")),
              idNoValid()
            ],
            citySelectResult: [
              required("请选择省市区")
            ],
            addressDetail: [
              required(required.message("详细地址")),
            ],
            relation1: [
              required(required.message("与紧急联系人一的关系")),
            ],
            emergency_name1: [
              required(required.message("紧急联系人一姓名")),
            ],
            emergency_phone1: [
              required(required.message("紧急联系人一手机号码")),
              chs_phone(chs_phone.message("紧急联系人一手机号码")),
            ],
            relation2: [
              required(required.message("与紧急联系人二的关系")),
            ],
            emergency_name2: [
              required(required.message("紧急联系人二姓名")),
            ],
            emergency_phone2: [
              required(required.message("紧急联系人二手机号码")),
              chs_phone(chs_phone.message("紧急联系人二手机号码")),
            ],
            phone: [
              required(required.message("本人手机号码")),
              chs_phone(chs_phone.message("本人手机号码")),
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            frontPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传身份证正面照片'));
                } else {
                  callback();
                }
              } }
            ],
            backPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传身份证反面照片'));
                } else {
                  callback();
                }
              } }
            ],
            selfPics: [
              { validator(rule, value, callback) {
                if(!value || value.length == 0) {
                  callback(new Error('请上传清晰自拍照片'));
                } else {
                  callback();
                }
              } }
            ]
          })
          .validate({ name, idNo, citySelectResult, addressDetail, 
        relation1, emergency_name1, emergency_phone1, relation2, emergency_name2, emergency_phone2,
         phone, captcha, frontPics, backPics, selfPics });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      if (this.emergency_name1 == this.emergency_name2) {
        return this.$dialog.toast({ mes: "紧急联系人不能同一个人" });
      }
      if (this.emergency_phone1 == this.emergency_phone2) {
        return this.$dialog.toast({ mes: "紧急联系人手机号不能一样" });
      }

      let address = this.citySelectModel.itemName1 + "[#]" + this.citySelectModel.itemName2 + "[#]" + this.citySelectModel.itemName3 + '[#]' + this.addressDetail;
      let emergencyContact = this.relation1 + '[#]' + this.emergency_name1 + '[#]' + this.emergency_phone1 + '[##]' + this.relation2 + '[#]' + this.emergency_name2 + '[#]' + this.emergency_phone2;
      let paramData = {
        name: this.name,
        cardId: this.idNo,
        phone: this.phone,
        captcha: this.captcha,
        address: address,
        cardImgFront: this.frontPics[0],
        cardImgBack: this.backPics[0],
        emergencyContract: emergencyContact,
        selfPicImg: this.selfPics[0],
        isPreCheck: true,
        location: this.location
      };
      realNameAuth(paramData).then(res => {
        paramData.isPreCheck = false;
        that.$router.push({
          path: "/user/auth_statement",
          query: paramData
        });
      }).catch(err => {
        that.$dialog.error(err.msg || "提交失败");
      });
    },
    async sendSMSCode() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("本人手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone, key: that.keyCode, code: that.codeVal })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },

    //======== start 定位 ========
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        this.initMap();
      }
    },

    async initMap() {
      try {
        //加载高德地图API
        this.AMap = await AMapLoader.load({
          key: 'fa774dbdacf0ce166f6c0d055702462d', //替换为你的key
          version: '2.0',
          plugins: [
            'AMap.Geolocation',  //定位插件
            //'AMap.Geocoder',     //逆地理编码插件
            //'AMap.CitySearch'    //IP定位插件
          ]
        });
        this.createMap();
      } catch (error) {
        console.error('地图加载失败:', error);
      }
    },

    createMap() {
      //创建地图实例
      this.map = new this.AMap.Map('mapContainer', {
        zoom: 12, //初始缩放级别
        resizeEnable: true //自适应窗口大小
      });
      
      this.initGeolocation();
    },

    initGeolocation() {
      const that = this;
      this.AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认：true
          timeout: 10000, // 设置定位超时时间，默认：无穷大
          offset: [10, 20],  // 定位按钮的停靠位置的偏移量
          zoomToAccuracy: true,  //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          position: 'RB' //  定位按钮的排放位置,  RB表示右下
        })

        geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        });

        function onComplete(data) {
          //data是具体的定位信息
          console.info('定位成功：' + JSON.stringify(data, null, 2));
          that.location = data.position.getLng() + ',' + data.position.getLat();
          //更新位置信息
          cookie.set(LATITUDE, data.position.getLat());
          cookie.set(LONGITUDE, data.position.getLng());
          //获取详情地址
          //getAddressDetail(data.position);
        }

        function onError(data) {
          //定位出错
           console.info('定位失败：' + JSON.stringify(data, null, 2));
           cookie.remove(LATITUDE);
           cookie.remove(LONGITUDE);
           //回退到IP定位
           //fallbackToIPLocation();
        }
        /*
        function getAddressDetail(position) {
          that.AMap.plugin('AMap.Geocoder', function () {
            const geocoder = new that.AMap.Geocoder({});
            geocoder.getAddress([position.lng, position.lat], function (status, result) {
              console.info('定位成功：' + JSON.stringify(result, null, 2));
              if (status === 'complete' && result.info === 'OK') {
                that.locationInfo.fullAddress = result.regeocode.formattedAddress;
                console.info('定位成功：' + JSON.stringify(that.locationInfo, null, 2))
              }
            });
          });
        }

        function fallbackToIPLocation() {  
          that.AMap.plugin('AMap.CitySearch', function () {
            const citySearch = new that.AMap.CitySearch();
            citySearch.getLocalCity(function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                //使用IP定位获取的城市信息
                that.locationInfo.fullAddress = result.city + '（IP定位）';
              } else {
                console.info('IP定位失败：');
                that.locationInfo.fullAddress = '自动定位失败';
              }
            });
          });
        }
        */
      })
    },
    //======== end 定位 ========= 
  }
};
</script>
<style scoped>
.ChangePassword {
  border-top: 1px solid #f0f0f0;
  background-color: rgb(245, 245, 245) !important;
  min-height: 100vh;
}

.ChangePassword .topTip {
  width: 100%;
  height: 0.60rem;
  background-color: #E98856;
  display: flex;
  align-items: center;
  padding-left: 0.50rem;
}

.ChangePassword .topTip .msg {
  color: white;
}

.ChangePassword .list {
  width: 100%;
  margin: 0 auto;
  /* padding: 0 0.5rem; */
}

.ChangePassword .list .module {
  background-color: #fff;
  margin-top: 0.13rem;
  padding: 0 0.5rem;
}

.ChangePassword .list .item-tile {
  width: 100%;
  height: 1.10rem;
  border-bottom: 0.02rem solid #f0f0f0;
  display: flex;
  justify-content: left;
  align-items: left;
  padding-left: 0.1rem;
}

.ChangePassword .list .item-tile .item-tile-name {
  width: 50%;
  text-align: left;
  height: 100%;
  line-height: 1.10rem;
  font-size: 0.34rem;
  font-weight: 500;
}

.ChangePassword .list .item {
  width: 100%;
  height: 1.10rem;
  border-bottom: 0.02rem solid #f0f0f0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 0.1rem;
}

.ChangePassword .list .item .item-name {
  width: 2.5rem;
  text-align: left;
  height: 100%;
  line-height: 1.10rem;
  font-size: 0.32rem;
}

.ChangePassword .list .item input {
  /* width: 75%; */
  height: 100%;
  font-size: 0.32rem;
  font-weight: normal;
  color: #000;
  border: none;
  outline: none;
}

.ChangePassword .list .item .picker {
  /* width: 60%; */
  height: 100%;
  font-size: 0.32rem;
  font-weight: normal;
  color: #000;
  border: none;
  outline: none;
  align-items: center;
}

.ChangePassword .list .item .placeholder {
  /* color: #b9b9bc; */
  font-size: 0.32rem;
  /* font-weight: 300; */
}

.ChangePassword .list .item input.codeIput {
  width: 2.50rem;
}

.ChangePassword .list .item .code {
  font-size: 0.32rem;
  background-color: #fff;
  /* border: 0.01rem solid #3E3841; */
  height: 100%;
  width: 3rem;
}

.ChangePassword .list .item .codeVal {
  width: 3rem;
  height: 0.6rem;
}

.ChangePassword .list .item .codeVal img {
  width: 100%;
  height: 100%;
}

.ChangePassword .list .item .code.on {
  color: #b9b9bc !important;
  border-color: #b9b9bc;
}

.ChangePassword .list .item .images {
  width: 1.60rem;
  height: 0.70rem;
  display: block;
}

.list .containerColumnOnly {
  margin-top: 0.50rem;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.list .containerColumnOnly2 {
  margin-top: 0.10rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-bottom: 0.3rem;
}

.list .picList {
  margin: 0.20rem auto;
  display: flex;
  flex-wrap: wrap;
}

.picList .pictrue {
  width: 2.40rem;
  height: 1.60rem;
  margin: 0.10rem;
  position: relative;
  font-size: 0.22rem;
  color: #bbb;
}

.picList .pictrue:nth-last-child(1) {
  border: 0.01rem solid #ddd;
  box-sizing: border-box;
}

.picList .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.03rem;
  object-fit: cover;
}

.picList .pictrue .icon-guanbi1 {
  font-size: 0.45rem;
  position: absolute;
  top: -0.20rem;
  right: -0.20rem;
  cursor: pointer;
}

.picList .pictrue .icon-icon25201 {
  color: #bfbfbf;
  font-size: 0.50rem;
}

.ChangePassword .confirmBnt {
  font-size: 0.32rem;
  width: 5.80rem;
  height: 0.90rem;
  border-radius: 0.45rem;
  color: #fff;
  margin: 0.92rem auto 0;
  text-align: center;
  line-height: 0.90rem;
  border: none;
  background-color: #007aff; /* 示例颜色 */
}

.ChangePassword .addConstomerBtn {
  font-size: 0.32rem;
  width: 5.80rem;
  height: 0.90rem;
  border-radius: 0.45rem;
  color: #E93323;
  margin: 0.60rem auto 0;
  text-align: center;
  line-height: 0.90rem;
  border: 1px solid #E93323;
  background-color: #fff;
}

.ChangePassword .bottom-padding {
  height: 1rem;
}


</style>
